export const wordCounter = (str) => {
  const removeHTMLRegex = /(<([^>]+)>)/gi;
  const contentRegex = /\S+/g;

  const content = str?.replace(removeHTMLRegex, '');
  return content?.match(contentRegex).length;
};
